import axios from "axios";

export default {
  namespaced: true,
  state: {
    juegosData: null
  },
  mutations: {
    setJuegosData(state, data) {
      state.juegosData = data;
    }
  },
  actions: {
    async fetchJuegosData({ state, commit }) {
      if (state.juegosData) return state.juegosData;
      const response = await axios.get("/api/games");
      const juegos = response.data;
      commit("setJuegosData", juegos);
      return juegos;
    }
  }
}